import React from 'react';

interface Props {
    term: string;
    description: string;
    isLoading?: boolean;
    skeleton?: JSX.Element;
    loanPayedDown?: boolean;
}

const LoanAccountDetails: React.FC<Props> = ({ term, description, isLoading, skeleton, loanPayedDown = false }) => {
    if (loanPayedDown) return null;

    return isLoading && skeleton ? (
        skeleton
    ) : (
        <>
            {description && (
                <>
                    <dt className="loan-account-details__term">{term}</dt>
                    <dd className="loan-account-details__description">
                        <strong>{description}</strong>
                    </dd>
                </>
            )}
        </>
    );
};

export default LoanAccountDetails;
